// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".google-visualization-tooltip{pointer-events:none}", ""]);
// Exports
module.exports = exports;
